import { render, staticRenderFns } from "./simple-modal.vue?vue&type=template&id=1d4f9904&scoped=true&"
import script from "./simple-modal.vue?vue&type=script&lang=js&"
export * from "./simple-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f9904",
  null
  
)

export default component.exports